export default __webpack_public_path__ + "static/media/trust.0bb6c14b.svg";